<template>
  <div>
    <!--    <div class="flex flex_gap_10">-->
    <!--      <div class="form-group flex-grow-1">-->
    <!--        <label>Препарат</label>-->
    <!--        <DrugSearchNew ref="selectedDrug"/>-->
    <!--      </div>-->
    <!--      <div class="form-group">-->
    <!--        <label>Количество</label>-->
    <!--        <input type="number" class="form-control" v-model="qty">-->
    <!--      </div>-->
    <!--      <div class="form-group align-self-end">-->
    <!--        <LoadingButton-->
    <!--          title="Добавить препарат"-->
    <!--          type="button"-->
    <!--          className="btn btn-outline-success"-->
    <!--          :onClick="() => addNewDrug()"-->
    <!--          :loading="loading"-->
    <!--          :color="$constants.SUCCESS_COLOR"-->
    <!--        />-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div v-if="!hideFileUpload">-->
    <UploadCustomWithPreview ref="uploadedFiles"
                             :extraData="{object: 'invoice_detail', objectId: newRecordId}"
    />
    <!--    </div>-->
    <div class="text-right">
      <LoadingButton
        v-if="+newQty"
        title="Добавить препарат"
        type="button"
        className="btn btn-outline-success"
        :onClick="() => addNewDrug()"
        :loading="loading"
        :color="$constants.SUCCESS_COLOR"
      />
    </div>
  </div>
</template>
<script>
import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";
import UploadCustomWithPreview from "@/components/images/UploadCustomWithPreview.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";

export default {
  props: ['invoiceId', 'onSave', 'newQty', 'selectedDrug'],
  components: {LoadingButton, UploadCustomWithPreview, DrugSearchNew},
  data() {
    return {
      qty: null,
      newRecordId: null,
      loading: false,
      hideFileUpload: false,
    }
  },
  methods: {
    async resetComponent() {
      // this.qty = null;
      // this.$refs.selectedDrug.drug = null;
      this.hideFileUpload = true;
      this.$refs.uploadedFiles.files = [];
      await this.$nextTick();
      this.hideFileUpload = false;
    },
    async addNewDrug() {
      if (!+this.newQty) {
        toastr['warning']('укажите количество', 'Внимание');
        return;
      }
      if (!this.selectedDrug?.id) {
        toastr['warning']('выберите препарат', 'Внимание');
        return;
      }
      this.loading = true;
      const {data} = await api.post('/invoices/details/update', {
        action: 'newIncomeDrug',
        drug_id: this.selectedDrug.id,
        qty: this.newQty,
        invoice_id: this.invoiceId
      })
      if (data.success) {
        if (this.$refs.uploadedFiles.files.length) {
          this.newRecordId = data.record.id;
          // this.$refs.uploadedFiles.data.object_id = data.record.id;
          // this.$refs.uploadedFiles.$refs.upload.active = true;
          await this.$refs.uploadedFiles.initUpload();
          let checkInterval = setInterval(async () => {
            if (!this.$refs.uploadedFiles.$refs.upload.active) {
              clearInterval(checkInterval);
              const uploadCheck = this.$refs.uploadedFiles.$refs.upload.files.find((f) => !f.success);
              if (uploadCheck) {
                toastr['warning']('некоторые файлы не загружены', 'Неуспешно')
              } else {
                this.resetComponent();
                if (this.onSave) this.onSave();
                toastr['success']('Файлы загружены', 'Успешно');
              }
            }
          }, 1000)
        } else {
          toastr['success']('Препарат добавлен', 'Успешно');
          this.resetComponent();
          if (this.onSave) this.onSave();
        }
      } else {
        toastr['warning'](data?.message ?? 'ошибка добавления препарата', 'Ошибка');
      }
      this.loading = false;
    }
  }
}
</script>
